











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReflectionGroupTitleEditor_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetroReflectionGroup",
      "kind": "LinkedField",
      "name": "reflectionGroups",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RetrospectiveMeeting",
  "abstractKey": null
};

(node ).hash = "c049ebe40bfeb52aabcbb74403574a99";

export default node;
